import React, { useEffect } from 'react'
import styled from 'styled-components'
import { connect } from 'react-redux'
import queryString from 'qs'
import { useTranslation } from 'react-i18next'

import { fetchListing } from '../../../actions/listingActions'
import { fetchStory } from '../../../actions/storyActions'
import { media, mediaMax } from '../../../styles/media'

import { BackLinkAnchor } from '../../../components/display/BackLink'

import Voucher from '../Voucher'
import VoucherCreateForm from './VoucherCreateForm'

const Wrapper = styled.div`
  .voucher {
    width: 100%;
    margin-bottom: 40px;
    ${media.md`
      height: 400px;
    `}
  }

  ${mediaMax.md`
    p {
      font-size: 16px;
    }
  `}
`

const PageTitle = styled.h1`
  font-size: 32px;
  ${media.md`
    font-size: 40px;
  `}
  margin: 24px 0;
  color: ${({ theme }) => theme.brand.forest};
`

const IntroSection = styled.div`
  width: 100%;
  padding: 16px 0;
`

const VoucherCreate = ({ dispatch, location, listing, story }) => {
  const { listing_id, story_id } = queryString.parse(location.search, {
    ignoreQueryPrefix: true,
  })

  const { t } = useTranslation('spelling')

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  useEffect(() => {
    if (story_id) {
      dispatch(fetchStory(story_id))
    } else if (listing_id) {
      dispatch(fetchListing(listing_id))
    }
  }, [listing_id, story_id])

  const suggestable = listing.data || story.data

  return (
    <Wrapper>
      <IntroSection>
        <div className="container">
          <BackLinkAnchor
            style={{ display: 'inline-block', marginBottom: 0 }}
            href="/vouchers"
          >
            Riparide Gift Vouchers
          </BackLinkAnchor>
          <PageTitle>
            <span style={{ textTransform: 'capitalize' }}>
              {t('personalize')}
            </span>{' '}
            your gift voucher
          </PageTitle>
        </div>
      </IntroSection>

      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-md-6">
            <Voucher
              title={suggestable && suggestable.title}
              backgroundImage={suggestable && suggestable.promo_image.medium}
              large
            />
          </div>
          <div className="col-xs-12 col-md-6">
            <VoucherCreateForm listing_id={listing_id} story_id={story_id} />
          </div>
        </div>
      </div>
    </Wrapper>
  )
}

export default connect(({ listing, story }) => ({
  listing,
  story,
}))(VoucherCreate)
